import { Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
const { delimited, either, map, option, right } = Parser;
/**
 * @internal
 */
export var Comparison;
(function (Comparison) {
    Comparison["LessThan"] = "<";
    Comparison["LessThanOrEqual"] = "<=";
    Comparison["Equal"] = "=";
    Comparison["GreaterThan"] = ">";
    Comparison["GreaterThanOrEqual"] = ">=";
})(Comparison || (Comparison = {}));
/**
 * @internal
 */
(function (Comparison) {
    function isInclusive(comparison) {
        return (comparison === Comparison.LessThanOrEqual ||
            comparison === Comparison.GreaterThanOrEqual ||
            comparison === Comparison.Equal);
    }
    Comparison.isInclusive = isInclusive;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-mf-lt}
     */
    Comparison.parseLessThan = map(delimited(option(Token.parseWhitespace), right(Token.parseDelim("<"), option(Token.parseDelim("=")))), (equal) => equal.isNone() ? Comparison.LessThan : Comparison.LessThanOrEqual);
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-mf-gt}
     */
    Comparison.parseGreaterThan = map(delimited(option(Token.parseWhitespace), right(Token.parseDelim(">"), option(Token.parseDelim("=")))), (equal) => equal.isNone() ? Comparison.GreaterThan : Comparison.GreaterThanOrEqual);
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-mf-eq}
     */
    Comparison.parseEqual = map(delimited(option(Token.parseWhitespace), Token.parseDelim("=")), () => Comparison.Equal);
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-mf-comparison}
     */
    Comparison.parse = either(Comparison.parseEqual, Comparison.parseLessThan, Comparison.parseGreaterThan);
})(Comparison || (Comparison = {}));
//# sourceMappingURL=comparison.js.map